var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialX = function SvgSocialX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0763 10.6179L20.6298 3H19.0768L13.3865 9.61448L8.84159 3H3.59961L10.4724 13.0023L3.59961 20.9908H5.15266L11.1618 14.0056L15.9615 20.9908H21.2035L14.0763 10.6179ZM5.71224 4.16911H8.09763L19.0776 19.8748H16.6922L5.71224 4.16911Z",
    fill: "var(--on-surface)"
  })));
};
export default SvgSocialX;